import { render, staticRenderFns } from "./SessionsIndex.vue?vue&type=template&id=65ec8258&scoped=true&"
import script from "./SessionsIndex.vue?vue&type=script&lang=js&"
export * from "./SessionsIndex.vue?vue&type=script&lang=js&"
import style0 from "./SessionsIndex.vue?vue&type=style&index=0&id=65ec8258&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ec8258",
  null
  
)

export default component.exports